<template>
  <div id="guide" @click="showI18nSwitcher=false" :style="{ backgroundImage: `url(${meta.bg})`, backgroundSize: 'cover', backgroundPosition: 'center' }">
    <logo large class="logo"/>

    <div class="btn-wrap">
      <div class="btn" id="btn1" @click="goToProfile">
        {{ $t('guide.manageMyProfile') }}
        <img src="../../views/guide/images/arr.png" alt="">
      </div>

      <div class="btn" id="btn2" @click="goToInfo">
        {{ $t('guide.checkDogTagInfo') }}
        <img src="../../views/guide/images/arr.png" alt="">
      </div>

      <div class="operating-guide-wrap">
        <img-modal type="guide"><i class="el-icon-info"></i> {{ $t('guide.guideBtn') }}</img-modal>
      </div>
    </div>

    <div class="guide-info-wrap">
      <p>{{ $t('guide.info[0]') }}</p>
      <p>{{ $t('guide.info[1]') }}</p>
      <p>{{ $t('guide.info[2]') }}</p>
    </div>

    <div class="i18n-wrap">
      <span class="i18n-tip">{{ $t('guide.languageSwitch') }}</span>
      <div class="i18n-img-wrap">
        <img alt="" src="@/assets/i18n.png" @click.stop="showI18nSwitcher=!showI18nSwitcher">
      </div>
      <ul :class="showI18nSwitcher && 'show'" class="i18n-switcher">
        <li :class="activeWhenAuto" @click="switchLanguage('auto')">Auto</li>
        <li :class="activeWhenEnglish" @click="switchLanguage('en-US')">English</li>
        <li :class="activeWhenFrench" @click="switchLanguage('fr-FR')">Français</li>
      </ul>
    </div>

    <custom-dialog
      v-model="showDialog"
      width="500"
      :confirmText="$t('base.ok')"
      cancelType="primary"
      :info="confirmInfo"
      :confirmBtnLoading="confirmBtnLoading"
      @confirm="confirmModel"
      @change="changeModel"
      :title="$t('base.notice')"><div></div>
    </custom-dialog>

  </div>
</template>

<script>
import meta from '../../utils/meta'
import axios from "../../utils/request.js";
import enUS from 'vant/es/locale/lang/en-US'
import frFR from 'vant/es/locale/lang/fr-FR'
import { Locale } from 'vant'
import el_enUS from 'element-ui/src/locale/lang/en'
import el_frFR from 'element-ui/src/locale/lang/fr'
import locale from 'element-ui/lib/locale'
import { getUserLanguage } from '../../main'
import ImgModal from "../../components/ImgModal.vue";

export default {
  name: 'guide',
  components: {ImgModal},
  data() {
    return {
      showDialog: false,
      confirmBtnLoading: false,
      confirmInfo: '',
      showI18nSwitcher: false,
      meta,
      lang: 1,
      showImgModal: false
    }
  },
  computed: {
    activeWhenAuto() {
      return !(this.activeWhenEnglish || this.activeWhenFrench) && 'active'
    },
    activeWhenEnglish() {
      return this.lang && localStorage.getItem('lang') === 'en-US' && 'active'
    },
    activeWhenFrench() {
      return this.lang && localStorage.getItem('lang') === 'fr-FR' && 'active'
    }
  },
  methods: {
    switchLanguage(lang) {
      this.lang++
      if (lang === 'auto') {
        localStorage.removeItem('lang')
        lang = getUserLanguage().includes('fr') ? 'fr-FR' : 'en-US'
      } else {
        localStorage.setItem('lang', lang)
      }
      this.$i18n.locale = lang
      // 动态切换 Vant 语言
      Locale.use(lang, lang === 'fr-FR' ? frFR : enUS)
      // 切换 Element-UI 语言
      locale.use(lang === 'fr-FR' ? el_frFR : el_enUS)
    },
    goToInfo() {
      this.showDialog = true;
    },
    goToProfile() {
      this.$router.push('/login')
    },
    /**
     * @desc 上传弹框关闭事件
     */
    changeModel() {
      this.showDialog = false;
    },
    /**
     * @desc 确定按钮事件
     */
    confirmModel(dogTagId) {
      this.confirmBtnLoading = true;
      // 处理业务逻辑相关的代码
      this.confirmBtnLoading = false;
      if(this.confirmInfo !== ''){
        this.showDialog = false
        this.confirmInfo = ''
        return false
      }

      if(!dogTagId) return false
      this.getDogInfo(dogTagId)
    },

    getDogInfo(dogTagId) {
      axios('/businese/dog_tag/getInfoByTagId?tagId=' + dogTagId)
        .then(({code, msg, data}) => {
          if (code === 200) {
            if(!data){
              this.showDialog = true
              this.confirmInfo = this.$t('guide["Tag ID does not exist. "]')
            }else{
              this.showDialog = false;
              this.$router.push('/checked_info?id=' + dogTagId)
            }

          } else {
            this.showDialog = true
            this.confirmInfo = msg
          }
        })
    }
  }
}
</script>

<style scoped>

#guide {
  width: 100vw;
  min-height: 100vh;
  background-size: cover;
  text-align: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5vw;
  padding: 0 41px;
}

.btn-wrap {
  width: 100%;
}

.btn {
  height: 58px;
  line-height: 58px;
  text-align: center;
  font-weight: 600;
  font-size: 18px;
  color: #FFFFFF;
  font-style: normal;
  cursor: pointer;
}

#btn1 {
  height: 58px;
  background: linear-gradient(125deg, #5EABF2 0%, #3B8BF2 100%);
  box-shadow: 0 7px 13px 0 rgba(5, 78, 171, 0.33);
  border-radius: 24px;
  margin-bottom: 16px;
}

#btn2 {
  height: 58px;
  background: linear-gradient(133deg, #F8B029 0%, #F6923D 100%);
  box-shadow: 0 8px 11px 0 rgba(171, 83, 3, 0.22);
  border-radius: 24px;
  margin-bottom: 10px;
}

.operating-guide-wrap i {
  color: #3291F8;
}

.guide-info-wrap > p {
  margin-block-start: 0;
  margin-block-end: 0;
  font-size: .8rem;
  text-align: left;
}

.i18n-wrap {
  display: flex;
  flex-direction: column;
  gap: 2vw;
  align-items: center;
}

.i18n-tip {
  color: #666;
  font-family: "Microsoft YaHei UI Light", "Microsoft YaHei UI", "Microsoft YaHei", serif;
}

.i18n-img-wrap > img {
  width: 24px;
}

.i18n-switcher {
  background-color: #eef0c6;
  border-radius: 15px;
  font-family: "Microsoft YaHei UI Light", "Microsoft YaHei UI", "Microsoft YaHei", serif;
  font-size: .9rem;
  box-shadow: 0 2px 5px #0002;
  transition: top .2s ease-out, opacity .2s;
  position: relative;
  opacity: 0;
  top: -10px;
}
.i18n-switcher.show {
  opacity: 1;
  top: 0;
}
.i18n-switcher > li {
  padding: 1.5vw 5vw;
  margin: 1vw;
  border-radius: 15px;
}
.i18n-switcher > .active {
  background-color: #e6dfbe;
  box-shadow: inset 1px 1px 3px #0001;
}

</style>



// WEBPACK FOOTER //
// src/views/guide/index.vue